import { z } from 'zod'

export const crossReferenceResponseSchema = z.object({
  status: z.enum(['results', 'empty_region', 'unclear']).default('results'),
  query: z.string(),
  candidates: z
    .array(
      z.object({
        text: z.string(),
        bbox: z.tuple([z.number(), z.number(), z.number(), z.number()]),
      })
    )
    .max(5)
    .default([]),
  selected_candidate: z.number().int().min(0).max(4).default(0),
  source_bbox: z
    .tuple([z.number(), z.number(), z.number(), z.number()])
    .nullable()
    .optional(),
  pipeline_config_id: z.string(),
  documents: z
    .array(
      z.object({
        result_key: z.string().optional(),
        sheet_number: z.string().nullable().optional(),
        revision_date: z.string().optional(),
        document_id: z.string().min(1),
        title: z.string(),
        drawing_number: z.string(),
        document_type: z.string(),
        revision_code: z.string(),
        page_number: z.number().int().positive().nullable(),
      })
    )
    .max(20),
})
export type CrossReferenceDocument = z.infer<
  typeof crossReferenceResponseSchema
>['documents'][number]
export type CrossReferenceOccurrence = {
  candidate_index?: number
  selected_text: string
  source_page_number: number
  point: [number, number]
  source_bbox?: [number, number, number, number]
}
export type CrossReferenceState = {
  occurrence: CrossReferenceOccurrence
  loading: boolean
  candidates?: z.infer<typeof crossReferenceResponseSchema>['candidates']
  selectedCandidate?: number
  emptyRegion?: boolean
  sourceBBox?: [number, number, number, number]
  query?: string
  documents?: CrossReferenceDocument[]
  error?: string
}
